import { Typography } from "@mui/material";

export default function Pageheader(props) {
  return (
    <Typography color="primary" variant="h4" fontWeight={"bold"}>
      {props?.headerName}
    </Typography>
  );
}
